module.exports = __webpack_public_path__ + "assets/img/4.ec4ba028.png";